import { useEffect, useRef } from "react";

// ✅ IntersectionObserver Hook
export const useInfiniteScroll = (
  loadMore,
  hasMore = true,
  threshold = 0.3,
) => {
  const observerRef = useRef(null);
  const observerInstanceRef = useRef(null);

  useEffect(() => {
    // Always clean up the previous observer
    if (observerInstanceRef.current) {
      observerInstanceRef.current.disconnect();
      observerInstanceRef.current = null;
    }

    if (!hasMore) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
          loadMore();
        }
      },
      { threshold },
    );

    observerInstanceRef.current = observer;
    const current = observerRef.current;
    if (current) observer.observe(current);

    return () => {
      observer.disconnect();
      observerInstanceRef.current = null;
    };
  }, [hasMore, loadMore, threshold]);

  return observerRef;
};
